import React from 'react';
import CloseIcon from "../Icons/CloseIcon";

interface Props {
    txt: string;
    remove?: Function
}

const Chip: React.FC<Props> = (props: Props) => {

    const remove = () => {
      if (props.remove) props.remove();
    }
    return (
      <div className="bg-neutral-600 rounded-full mt-2 py-1.5 px-3 mr-2 flex items-center">
          <div className="text-sm font-medium">{props.txt}</div>
          {
            props.remove &&
                  <CloseIcon aria-label="Delete" className="ml-2 h-4 w-4 cursor-pointer text-white!" onClick={() => remove()}/>
          }

      </div>
    );
};

export default Chip;
